const scrollIsBottom = (el) => {
  return el.scrollHeight <= (el.offsetTop + el.clientHeight + el.scrollTop)
}

const scrollIsTop = (el) => {
  return el.scrollTop >= 5
}

export { scrollIsBottom, scrollIsTop }
